/* eslint-disale */
import { lazy } from 'react';
import { Switch } from 'react-router-dom';
import { Route, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const UserProfile = lazy(() => import('../../container/users/overview/UserProfile'));

function ProfileRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}`} component={UserProfile} />
    </Switch>
  );
}

export default ProfileRoutes;
